import PoliciesPage from './components/PoliciesPage';

const routes = [
  {
    path: '/policies',
    name: 'menu.policies',
    icon: 'blockquote-left',
    // customIcon: true,
    loginRequired: true,
    component: PoliciesPage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
